/**
 * Parses a Boolean from a string. Currently only converts the True/true/False/false string values.
 * @param value The string to parse.
 * @returns Boolean value or null if not a valid string.
 */
export function parseBoolean(value: string): boolean | null {

	const lcase = value?.toLowerCase();
	if (lcase === "true") {
		return true;
	}
	else if (lcase === "false") {
		return false;
	}
	else {
		return null;
	}
}